// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { Rule } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "../../../types";
import type { IGetRulesParams } from "./Rules";

interface RulesInstance {
	get(q: IGetRulesParams): Promise<Rule[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<Rule>;
}

// Module-level singleton instance
let instance: RulesInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createRules(): RulesInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}

	const baseAdmin = baseAdminInstance;
	const baseUrl = baseAdmin.namespaceUrl.concat("/rules");

	return {
		get: async (q: IGetRulesParams): Promise<Rule[]> => {
			const url = new URL(baseUrl);
			baseAdmin.appendJsonSearchParams(url, { q });
			try {
				return await baseAdmin.getRequest<Rule[]>(url);
			} catch (err) {
				baseAdmin.onError(err);
				return Promise.reject(err);
			}
		},
		getByUid: async (uid: string, q?: QueryPayload): Promise<Rule> => {
			const url = new URL(baseUrl.concat(`/${uid}`));
			if (q) baseAdmin.appendJsonSearchParams(url, q);
			try {
				return await baseAdmin.getRequest<Rule>(url);
			} catch (err) {
				baseAdmin.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getRulesInstance(): RulesInstance {
	if (!instance) {
		instance = createRules();
	}
	return instance;
}
